import { Module } from "../../classes/mvc/Module";
import { ControllerHTML2PDF } from "./ControllerHTML2PDF";
import { ModelHTML2PDF } from "./ModelHTML2PDF";

export class ModuleHTML2PDF extends Module<ModelHTML2PDF> {
    
    public constructor( configuration:Object ) {
        // Module-Name: HTML2PDF
        // configuration: YAML Node(HTML2PDF -> module:HTML2PDF)
        // YAML-Configuration-Option
        // modules: (Nodename in YAML-File for the module configuration. If this node is not in your YAML-File, then please add the configuration to your YAML-File)
        //  HTML2PDF (Nodename in modules must match to the module_name, which is defined in the constructor of the Menu-Class -> super("HTML2PDF") )
        //      active: true (mandatory-definition [true|false] -> set module to active or deactive)
        //      components: (All html-templates)
        //          foundation: (html-template target framework definition. You can add for each framework or target html system your own html-templates.)
        //              html_template_setting: html_source (HTML+Handlebars Elements)
        //              html_template_setting1: html_sourc1 (HTML+Handlebars Elements)
        //      config: (Nodename for module-configurations. Under this node you can add all configuration options)
        //          setting_name: setting_value
        //          setting_name1: setting_value1
        //      lables: (Nodename for all module labels. ISO-Language-Code for language identification.)
        //              de:
        //                  lable_name: Hallo Welt!
        //              en: 
        //                  lable_name: Hello World!

        // Master-Template: YAML
        // HTML2PDF:
        //    active: true
        //    components:
        //        foundation: 
        //            pdf_html_template: <h1>Hello World</h1>
        //    config: 
        //        paper_size: A4 
        //    labels: 
        //        de:
        //          lable_name: Hallo Welt!
        //        en:
        //          lable_name: Hello World!



        super( "HTML2PDF", configuration );

        let outputContainer = jQuery("#html-to-pdf");

        if ( outputContainer.length > 0 ) {
            let controller = new ControllerHTML2PDF( this.getName(), this.getAccessID(), outputContainer );

            this.addController(controller);
        }
    }

    public run() {
        this.runAllControllers();
    }

    public onControllersInitialized(): void {
        
    }
}